import { z } from 'zod'
import { textoObrigatorio } from './comum'

/** Etiquetas (5.2) e motivos de perda (4.2 / 5.2). Duas listas simples. */

const corSchema = z
  .string()
  .trim()
  .regex(/^#[0-9a-fA-F]{6}$/, 'use uma cor no formato #RRGGBB')

export const criarTagSchema = z.object({
  nome: textoObrigatorio('nome da etiqueta', 60),
  cor: corSchema.default('#64748b'),
})
export type CriarTagEntrada = z.infer<typeof criarTagSchema>

export const atualizarTagSchema = z.object({
  nome: textoObrigatorio('nome da etiqueta', 60).optional(),
  cor: corSchema.optional(),
})

export interface TagDto {
  id: string
  nome: string
  cor: string
  contatos: number
}

/**
 * A cor da letra que se lê sobre o fundo da etiqueta: branca no fundo escuro,
 * quase preta no claro.
 *
 * A letra era branca em todas, e numa etiqueta amarela ficava
 * ilegível. Pela luminância relativa (a mesma conta do contraste da WCAG),
 * vence a letra que dá mais contraste com aquele fundo, para qualquer cor que
 * alguém venha a escolher na Configuração.
 */
export function corDoTextoSobre(fundo: string): '#ffffff' | '#1c1917' {
  const hex = /^#([0-9a-f]{6})$/i.exec(fundo.trim())?.[1]
  if (!hex) return '#ffffff'

  const canal = (inicio: number) => {
    const c = parseInt(hex.slice(inicio, inicio + 2), 16) / 255
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4
  }
  const luminancia = 0.2126 * canal(0) + 0.7152 * canal(2) + 0.0722 * canal(4)

  // Contraste com o branco (luminância 1) e com o quase preto (#1c1917, ~0,010).
  const comBranco = 1.05 / (luminancia + 0.05)
  const comEscuro = (luminancia + 0.05) / (0.01 + 0.05)
  return comBranco >= comEscuro ? '#ffffff' : '#1c1917'
}

export const criarMotivoPerdaSchema = z.object({
  nome: textoObrigatorio('motivo', 120),
})
export type CriarMotivoPerdaEntrada = z.infer<typeof criarMotivoPerdaSchema>

export const atualizarMotivoPerdaSchema = z.object({
  nome: textoObrigatorio('motivo', 120).optional(),
  ativo: z.boolean().optional(),
})

export interface MotivoPerdaDto {
  id: string
  nome: string
  ativo: boolean
  perdas: number
}
